// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_52f7ccf3"};